import { forwardRef, ReactNode } from "react";
import classNames from "classnames";

interface Props {
  title: ReactNode;
  children?: React.ReactNode;
  className?: string;
  heightClassName?: string;
  titleBackgroundClassName?: string;
}

export const borderWidth = 2;

export default forwardRef<HTMLDivElement, Props>(function GameBoxWithTitle(
  { title, children, className, heightClassName, titleBackgroundClassName },
  ref
) {
  return (
    <div
      ref={ref}
      className={classNames(
        "relative z-0 box-border w-full border border-white bg-black text-white",
        heightClassName ?? "h-96",
        className
      )}
      style={{ borderWidth }}
    >
      <div
        className={classNames(
          "z-10 inline-block rounded-br p-2 font-brik text-xl leading-none sm:text-3xl",
          titleBackgroundClassName ?? "bg-black/50"
        )}
      >
        {title}
      </div>

      {children}
    </div>
  );
});
